import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Map } from 'immutable';
import { truncate } from 'lodash';
import { AiOutlineFileText } from 'react-icons/ai';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  className: PropTypes.string,
};

function Details({ event, settings, className = '', withIcon = false }) {
  if (!event.get('description')) return <span />;
  if (withIcon) {
    return (
      <div style={{ display: 'flex', marginRight: 10 }}>
        <div style={{ width: 25, marginRight: 5 }}>
          <AiOutlineFileText size={25} />
        </div>
        <div className={cn('description')} style={{ textAlign: 'left', marginTop: 0 }}>
          {settings.get('characterSize') > 0 ? (
            <div
              dangerouslySetInnerHTML={{
                __html: truncate(event.get('description'), {
                  length: settings.get('characterSize'),
                }),
              }}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ width: 25, marginRight: 5 }}>
        <AiOutlineFileText size={25} />
      </div>
      <div className={cn('description', className)} style={{ textAlign: 'left', marginTop: 0 }}>
        {settings.get('characterSize') > 0
          ? truncate(event.get('description'), { length: settings.get('characterSize') })
          : ''}
      </div>
    </div>
  );
}

Details.propTypes = propTypes;

export default Details;



// WEBPACK FOOTER //
// ./src/widget/event_components/details.js